import React from 'react';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CustomXAxisTick, CustomTooltip, useTooltipToggle } from '../shared';

interface BloodPressureChartProps {
  data: any[];
}

/**
 * 血圧脈拍グラフコンポーネント（縦棒 + 折れ線）
 */
export const BloodPressureChart: React.FC<BloodPressureChartProps> = ({ data }) => {
  const { tooltipActive, handleChartClick, handleChartLeave } = useTooltipToggle();

  // 血圧範囲（収縮期〜拡張期）を計算
  const chartData = data.map(point => ({
    ...point,
    bloodPressureRange: (point.blood_pressure_sys && point.blood_pressure_dia)
      ? [point.blood_pressure_dia, point.blood_pressure_sys]
      : [null, null]
  }));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart
        data={chartData}
        margin={{ top: 20, right: -15, left: -15, bottom: 20 }}
        onClick={handleChartClick}
        onMouseLeave={handleChartLeave}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0"/>
        <XAxis
          dataKey="date"
          tick={<CustomXAxisTick />}
          stroke="#666"
          interval={0}
        />
        {/* 左側Y軸（血圧用） */}
        <YAxis
          yAxisId="left"
          domain={[30, 180]}
          ticks={[30, 60, 85, 90, 120, 135, 150, 180]}
          tick={{ fontSize: 16, fontWeight: 'bold' }}
          stroke="#666"
          axisLine={false}
          tickLine={false}
        />
        {/* 右側Y軸（脈拍用） */}
        <YAxis
          yAxisId="right"
          orientation="right"
          domain={[30, 180]}
          ticks={[30, 60, 85, 90, 120, 135, 150, 180]}
          tick={{ fontSize: 16, fontWeight: 'bold' }}
          stroke="#666"
          axisLine={false}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip chartData={data} />} active={tooltipActive} trigger="click" />
        {/* 血圧範囲を縦棒で表示 */}
        <Bar
          yAxisId="left"
          dataKey="bloodPressureRange"
          fill="#00A960"
          barSize={10}
          radius={[5, 5, 5, 5]}
        />
        {/* 脈拍を折れ線で表示 */}
        <Line
          yAxisId="right"
          type="linear"
          dataKey="pulse"
          name="脈拍"
          stroke="#808080"
          strokeWidth={2}
          dot={{ fill: '#808080', r: 7, stroke: '#ffffff', strokeWidth: 1 }}
          activeDot={tooltipActive ? { r: 9 } : false}
          connectNulls
          animationDuration={600}
          animationEasing="ease-out"
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
};

export default BloodPressureChart;
